import Request from "../models/utils/Request";

import * as actionTypes from "../constants/actionTypes";
import * as modelHelper from "../helpers/modelHelper";

const initialState = {
    configuration: null,
    connected: false,
    dialog: null,
    expected: [],
    requests: [],
    sequence: 0,
    showDialog: false,
    isOnline: false,
    file: null,
    progress: 0,
    downloadedLogArchiveLength: 0,
    totalLogArchiveLength: 0,
    logArchivePath: null,
    size: 0,
    downloadedSize: 0
};

/**
 * Structure of Helper Server store:
 * - configuration {Object}                - update configuration
 * - connected {Boolean}                   - if true, client is connected to Redlike Helper Server
 * - dialog {Object}                       - if not null, Redlike Helper Server dialog is opened
 * - expected {Array}                      - array of Helper Server asynchronous responses
 * - requests {Array}                      - array of Helper Server requests in progress
 * - sequence {Number}                     - index for client - Redlike Helper Server communication
 * - showDialog {Boolean}                  - show Redlike Helper dialog or keep it minimized
 * - isOnline {Boolean}                    - if true, Redlike Helper has internet connection
 * - file {Object}
 * - progress {Number}                     - percentage of downloaded file
 * - downloadedLogArchiveLength {Number}   - remaining length of Log Archive
 * - totalLogArchiveLength {Number}        - total length of Log Archive
 * - logArchivePath {String}               - the path where the log archive is being saved
 * - size {Number}                         - size of the whole downloading file
 * - downloadedSize {Number}               - size of the already downloaded part
 */
export const helperReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.HELPER_WEBSOCKET_OPENED:
            return {
                ...state,
                connected: true
            };
        case actionTypes.HELPER_WEBSOCKET_CLOSED:
            return {
                ...state,
                connected: false,
                requests: [],
                sequence: 0
            };
        case actionTypes.SAVE_HELPER_WEBSOCKET_REQUEST:
            if (action.payload.method === undefined || action.payload.tabId === undefined) {
                return {
                    ...state,
                    sequence: action.payload.sequence
                };
            }

            return {
                ...state,
                sequence: action.payload.sequence,
                requests: state.requests.concat([
                    new Request(action.payload.sequence, action.payload.tabId, action.payload.method)
                ])
            };
        case actionTypes.REMOVE_HELPER_WEBSOCKET_REQUEST:
            let filteredRequests = state.requests.filter((request) => request.id !== action.payload.sequence);

            return {
                ...state,
                requests: filteredRequests === undefined ? [] : filteredRequests
            };
        case actionTypes.SAVE_HELPER_ASYNC_RESPONSE:
            if (
                action.payload.id === undefined ||
                action.payload.tabId === undefined ||
                action.payload.method === undefined
            ) {
                return state;
            }

            return {
                ...state,
                expected: state.expected.concat([
                    new Request(action.payload.id, action.payload.tabId, action.payload.method)
                ])
            };
        case actionTypes.REMOVE_HELPER_ASYNC_RESPONSE:
            let filteredExpRequests = state.expected.filter((response) => response.id !== action.payload.id);

            return {
                ...state,
                expected: filteredExpRequests === undefined ? [] : filteredExpRequests
            };
        case actionTypes.SAVE_HELPER_DIALOG:
            return {
                ...state,
                dialog: action.payload.dialog,
                size: 0,
                downloadedSize: 0
            };
        case actionTypes.SAVE_HELPER_UPDATE_CONFIGURATION:
            return {
                ...state,
                configuration: modelHelper.mapHelperConfiguration(action.payload.configuration)
            };
        case actionTypes.SAVE_HELPER_IS_ONLINE:
            return {
                ...state,
                isOnline: action.payload.isOnline
            };
        case actionTypes.HELPER_SAVE_SHOW_DIALOG:
            return {
                ...state,
                showDialog: action.payload.showDialog
            };
        case actionTypes.HELPER_OPEN_DIALOG:
            return {
                ...state,
                showDialog: true
            };
        case actionTypes.HELPER_SAVE_DOWNLOADED_PROGRESS:
            return {
                ...state,
                size: action.payload.size,
                downloadedSize: action.payload.downloadedSize
            };
        case actionTypes.HELPER_SAVE_DOWNLOADED_LOG_ARCHIVE_LENGTH:
            return {
                ...state,
                downloadedLogArchiveLength: action.payload.downloadedLength
            };
        case actionTypes.HELPER_SAVE_LOG_ARCHIVE_PATH:
            return {
                ...state,
                logArchivePath: action.payload.logArchivePath
            };
        case actionTypes.HELPER_RESET_LOG_ARCHIVE_PARAMETERS:
            return {
                ...state,
                logArchivePath: null,
                downloadedLogArchiveLength: 0,
                totalLogArchiveLength: 0
            };
        case actionTypes.HELPER_SAVE_TOTAL_LOG_ARCHIVE_LENGTH:
            return {
                ...state,
                totalLogArchiveLength: action.payload.totalLength
            };
        default:
            return state;
    }
};
